import { createSelector } from 'reselect';
import { CompareActions, UnifiedCompareGroup } from './types';
import { getUserActionLoading, getManageLoading } from './selectors/loadings';
import { getUnifiedCompareData, getUserAction } from './selectors/base';
import { getManageError } from './selectors/errors';

export const getUserLastActionData = createSelector(getUserAction, (userAction) => ({
  ...userAction,
  action: userAction.action === 'request' ? CompareActions.ADD : userAction.action,
}));

export const getCompareGroup = (groupId: string) =>
  createSelector(getUnifiedCompareData, (data) => data?.[groupId] as UnifiedCompareGroup | undefined);

export const getCompareGroupProductIds = (groupId: string) =>
  createSelector(getCompareGroup(groupId), (group) => (group ? Object.keys(group.productsData) : []));

export const getCompareGroupProductsData = (groupId: string) =>
  createSelector(getCompareGroup(groupId), (group) => group?.productsData || {});

export const getIsDataLoadedForGroup = (groupId: string) =>
  createSelector(getCompareGroup(groupId), (group) => group?.isDataLoaded || false);

export const getIsInComparison = (groupId: string, productId: string) =>
  createSelector(getCompareGroupProductsData(groupId), (productsData) => !!productsData[productId]);

export const getProductsCompareListsState = createSelector(
  [getManageLoading, getManageError],
  (manageLoading, error) => {
    if (error.error) {
      return 'error';
    }

    return manageLoading;
  },
);

export const getProductsCompareLists = createSelector(getUnifiedCompareData, (data) =>
  Object.values(data || {}).map((group) => ({
    name: group.name,
    groupId: group.groupId,
    products: Object.keys(group.productsData),
  })),
);

export const getOperationProductsCompareLists = createSelector([getUserAction], (userAction) => ({
  operation: userAction.action,
  lastProductDelete: userAction.productId,
}));

export const getOperationProductsCompareListsIsLoading = createSelector(
  [getUserActionLoading],
  (loading) => loading,
);
